import { actions as loadingActions } from "../../components/loading/index";
import {history} from '../../extendedBrowserRouter'
import {
  notification
} from "antd";
//https://us-central1-vedicplatform.cloudfunctions.net/codechefSolvedProblems/api/solved_problems/v1.0/devihhs
//https://us-central1-vedicplatform.cloudfunctions.net/geeksforgeeksSolvedProblems/api/solved_problems/v1.0/DevBhushan
//https://us-central1-vedicplatform.cloudfunctions.net/hackerearthSolvedProblems/api/user_profile/v1.0/dev12321
//https://us-central1-vedicplatform.cloudfunctions.net/hackerankSolvedProblems/api/problem_submissions/v1.0/devbhushan12321

/* eslint-disable import/first */

export const loadStudentWithSkills = (skillName,category) => {
  if(!category){
    category="Student"
  }
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    dispatch(loadingActions.showLoading());


  
    // const dbRef = category && category=='Student' ? firestore.collection("students").where('role', '==', 'STUDENT').where("technicalSkillsArray", "array-contains-any", [skillName]) :  firestore.collection("students")
    // .where("role", "in", ["HOD", "PRINCIPAL", "FACULTY"]).where("technicalSkills", "array-contains-any", [skillName])
  

    firestore.collection("students")
    .where("technicalSkillsArray", "array-contains-any", [skillName])
    .get()
    .then(doc => {
      if(!doc.empty){
        var resdata = [];
        
        if(category=="Student"){
          doc.docs.map((doc, i) => {
            if(doc.data() && doc.data().role && doc.data().role=="STUDENT"){
              resdata.push({ key: `${i}`, ...doc.data(),...doc.data().technicalSkills[skillName] })
            }
          })
        }
        else{
          doc.docs.map((doc, i) => {
            if(doc.data() && doc.data().role && doc.data().role!="STUDENT"){
              resdata.push({ key: `${i}`, ...doc.data(),...doc.data().technicalSkills[skillName] })
            }
          })
        }
      // 
      dispatch({
        
        type: "LOAD_SKILL",
        payload: !doc.empty
          ? {
              skillName,
              valid: true,
              skillData:doc.docs.map((doc, i) => {
                return { key: `${i}`, ...doc.data().technicalSkills[skillName] };
              }),
              skeltonLoading:false,
              data: resdata
            }
          : { skillName, valid: false }
      });
      dispatch(loadingActions.hideLoading());
    }
    else{
      dispatch({
        type: "LOAD_CAMPUS_DASHBOARD_DATA",
        payload: { valid: false }
      });
      dispatch(loadingActions.hideLoading());
      notification.error({
        message: skillName + ' Skill Not found in Database. ',
        description:
          'Redirected to overall Dashboard'
      });
      
      history.push('/home/campusDashboard/ADMIN')
    }
    })
    .catch(function(error) {
      notification.error({
        message: 'Something went Wrong',
        duration:0,
        description:
          'Contact admin@vedic.dev '+error,
        onClick: () => {
          
        },
      });
      
      dispatch(loadingActions.hideLoading());
    });
};
};

export const loadassessmentProfile = (assessmentProfile,category) => {
  console.log('category: ', category);
  if(!category){
    category="Student"
  }
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    dispatch(loadingActions.showLoading());

   if(assessmentProfile=='internships'){
    assessmentProfile='InternshipAttended'
   }
   if(assessmentProfile=='skills'){
    assessmentProfile='technicalSkills'
   }
   if(assessmentProfile=='projects'){
    assessmentProfile='projectsDoneList'
  }
  if(assessmentProfile=='certifications'){
    assessmentProfile='certification'
  }
  if(assessmentProfile=='conferences'){
    assessmentProfile='conferenceAttended'
  }
  if(assessmentProfile=='publications'){
    assessmentProfile='pubications'
  }
  if(assessmentProfile=='workshops'){
    assessmentProfile='workshopsAttended'
  }
  
  const dbRef = category && category=='Student' ? firestore.collection("students").where('role', '==', 'STUDENT') :  firestore.collection("students")
  .where("role", "in", ["HOD", "PRINCIPAL", "FACULTY"]).orderBy(assessmentProfile, "asc")

  console.log('dbRef: ', dbRef);

    dbRef
      .get()
      .then(doc => {
        dispatch({
          type: "LOAD_assessment_PROFILE_DATA",
          payload: !doc.empty
            ? { [assessmentProfile]: {
                assessmentProfile,
                valid: true,
                skeltonLoading:false,
                data: (doc.docs.map((doc, i) => {
                  if(doc.data()[assessmentProfile] && Object.keys(doc.data()[assessmentProfile]).length>0){
                  return { key: `${i}`, ...doc.data() };
                  }
                })).filter(function( element ) {
                  return element !== undefined;
               })
              } }
            : { [assessmentProfile]: { assessmentProfile,data:[], valid: false } }
        });
        dispatch(loadingActions.hideLoading());
      })
      .catch(function(error) {
        notification.error({
          message: 'Something went Wrong',
          duration:0,
          description:
            'Contact admin@vedic.dev '+error,
          onClick: () => {
            
          },
        });
        
        dispatch(loadingActions.hideLoading());
      });
  };
};
